import type { AlertProps as MuiAlertProps, AlertTitleProps } from '@mui/material';
import { Alert as MuiAlert, AlertTitle } from '@mui/material';
import type { ReactNode } from 'react';
export interface AlertProps extends Omit<MuiAlertProps, 'title'> {
  title?: ReactNode | string;
  description?: ReactNode | string;
  titleProps?: AlertTitleProps;
}
export function ToastAlert(props: AlertProps) {
  const {
    title,
    description,
    titleProps,
    ...alertProps
  } = props;
  return <MuiAlert {...alertProps} data-sentry-element="MuiAlert" data-sentry-component="ToastAlert" data-sentry-source-file="ToastAlert.tsx">
      {!!title && <AlertTitle {...titleProps}>{title}</AlertTitle>}
      <span>{description}</span>
    </MuiAlert>;
}